import React from 'react'
import p1 from '../assets/whatwedo.png'

const AboutSection4 = () => {
    return (
        <div className='h-auto flex flex-col gap-9 items-center relative px-4 sm:px-8 md:px-16 lg:px-24 py-10'>
            <p className='text-[22px] sm:text-[26px] md:text-[32px] lg:text-[34px] font-semibold text-center leading-snug'>
                What We Do
            </p>

            <div className='flex flex-col lg:flex-row gap-10 lg:gap-[72px] items-center'>
                <div className='w-full lg:w-[400px]'>
                    <img src={p1} alt='what we do' className='w-full h-auto object-contain' />
                </div>

                <div className='w-full lg:w-[500px] text-[14px] sm:text-[15px] md:text-[17px] leading-relaxed text-justify font-nunito'>
                    <p className='pb-4'>
                        We want to be recognized as a leading provider of Digital Marketing and Software Development services. We are committed to earning our clients’ trust through outstanding execution and uncompromising dedication to their success.
                    </p>
                    <p>
                        Our mission is to achieve client business goals with quality software development services. We strive to provide consistently successful, unique, and forward-thinking digital marketing that takes into account the individual requirements and unique demands of each client.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default AboutSection4
